module.exports = __webpack_public_path__ + "img/27ac46c.jpg";